/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

import React from 'react';
import { Tabs } from '@radix-ui/themes';

import { NotAvailableTab } from './NotAvailableTab';
import { QuarantineListView } from './QuarantineListView';
import { QUARANTINE_STRINGS as STRINGS } from './quarantine.strings';

export function QuarantineTabsView(): JSX.Element {
  return (
    <Tabs.Root defaultValue="quarantine">
      <Tabs.List>
        <Tabs.Trigger value="quarantine" data-analytics-id="nxrm-security-quarantine-tab-quarantine-tab">
          {STRINGS.tabs.quarantine}
        </Tabs.Trigger>
        <Tabs.Trigger value="cached-risk" data-analytics-id="nxrm-security-quarantine-tab-cached-risk-tab">
          {STRINGS.tabs.cachedRisk}
        </Tabs.Trigger>
        <Tabs.Trigger value="containers" data-analytics-id="nxrm-security-quarantine-tab-containers-tab">
          {STRINGS.tabs.containers}
        </Tabs.Trigger>
      </Tabs.List>

      <Tabs.Content value="quarantine" mt="4">
        <QuarantineListView />
      </Tabs.Content>
      <Tabs.Content value="cached-risk" mt="4">
        <NotAvailableTab />
      </Tabs.Content>
      <Tabs.Content value="containers" mt="4">
        <NotAvailableTab />
      </Tabs.Content>
    </Tabs.Root>
  );
}
